import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/administrativo/setores${queryUrl}`)
  },
  insertNewSector(data) {
    return axios.post('/administrativo/setores', data)
  },
  editSector(data) {
    return axios.put(`/administrativo/setores/${data.id}`, data)
  },
  deleteSector(id) {
    return axios.delete(`/administrativo/setores/${id}`)
  },
}
